import { SafeStyle } from "@angular/platform-browser";

export class Projectperson {
    projectId:string;
    personId:string;
    fullname:string;
    title:string;
    subtitle?:string;
    shortdescription?:string;
    projectdescription?:string;
    projectscope?:string;
    projectlocation?:string;
    projectrole:string;
    im?:string;
    phone?:string;
    email?:string;
    relationtype?:string;
    date_added?:string;
    date_joined?:string;
    start_date:Date;
    end_date:Date;
    organization:string;
    isactive:boolean;
    lastupdated:number;
    iscustomer: boolean;
}
